// extracted by mini-css-extract-plugin
export var aboveInput = "_o3-0";
export var actionButton = "_o3-5";
export var actionButtonContainer = "_o3-1";
export var actionIcon = "_o3-6";
export var aiInfoContainer = "_o3-2";
export var attachmentWrapper = "_o3-7";
export var bold = "_o3-3";
export var checkIcon = "_o3-8";
export var clickingRecipientBar = "_o3-11";
export var commentThreadSwitch = "_o3-a";
export var draftImage = "_o3-b";
export var draftImageContainer = "_o3-c";
export var draftImages = "_o3-e";
export var editButton = "_o3-g";
export var editor = "_o3-f";
export var editorContainer = "_o3-y";
export var editorErrorTooltipWrapper = "_o3-9";
export var headerDivider = "_o3-h";
export var icon = "_o3-i";
export var info = "_o3-j";
export var internal = "_o3-n";
export var internalDivider = "_o3-k";
export var internalMessage = "_o3-l";
export var messageInputCard = "_o3-m";
export var messageInputForm = "_o3-o";
export var messageInputFormInternal = "_o3-p";
export var options = "_o3-q";
export var publicMessageCustomer = "_o3-s";
export var publicMessageMerchant = "_o3-r";
export var removeImageButton = "_o3-d";
export var replyButtons = "_o3-t";
export var showSignatureButton = "_o3-u";
export var spinner = "_o3-v";
export var verticalButtonDivider = "_o3-4";
export var visibilitySelector = "_o3-w";
export var warning = "_o3-x";
export var wrappingText = "_o3-z";
export var writingInternalNoteTopBorder = "_o3-10";